import { UpdateResidentInput } from "../../API";
import {
	Button,
	Grid,
	TextField,
	Typography,
	FormControlLabel,
	FormControl,
	InputLabel,
	OutlinedInput,
	Paper,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, { useEffect, useState } from "react";
import { Link as RouterLink, RouteComponentProps } from "react-router-dom";
import IntakeService from "../Intake/IntakeService";
import AdminService from "../Admin/AdminService";
import { intersection, map } from "lodash";
import { Checkbox } from "@mui/material";
import EventService from "../../EventService";
import moment from "moment";

var validator = require("validator");

const useStyles = makeStyles({
	checkedGreen: {
		color: "green !important",
	},
	checkedRed: {
		color: "red !important",
	},
	label: {
		display: "flex",
		alignItems: "center",
	},
	formControl: {
		width: "100%",
		marginBottom: "16px",
	},
	input: {
		color: "#000",
		"& .MuiInputLabel-outlined": {
			color: "#000",
		},
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "#000",
		},
		"& .MuiInputBase-input": {
			color: "#000",
		},
		"&.Mui-disabled": {
			color: "#000",
			"& .MuiOutlinedInput-notchedOutline": {
				borderColor: "#000",
			},
			backgroundColor: "#fff",
			"& .MuiInputBase-input": {
				color: "#000",
			},
		},
	},
	labelText: {
		color: "#000",
	},
	title: {
		fontWeight: "bold",
		marginBottom: "16px",
		marginTop: "16px",
	},
	paper: {
		padding: "24px",
		border: "1px solid rgba(0, 0, 0, 0.23)",
		borderRadius: "4px",
		boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
	},
	sectionTitle: {
		fontWeight: "bold",
		marginBottom: "8px",
	},
});

interface DetailPageRouteProps {
	page: string;
	intakeId: string;
	pid: string;
}

interface RouteProps extends RouteComponentProps<DetailPageRouteProps> { }

export default function UpdateThere(props: RouteProps) {
	const { pid } = props.match.params;

	const classes = useStyles();

	const [error, setError] = useState<string>("");
	const [initialUserInfo, setInitialUserInfo] = useState<UpdateResidentInput>();
	const [userInfo, setUserInfo] = useState<UpdateResidentInput>();
	const [hasAccess, setAccess] = useState<boolean>(false);

	console.log("userInfo: ", userInfo);
	console.log("INITIAL userInfo", initialUserInfo);

	// const { pid } = props.match.params;
	useEffect(() => {
		console.log("PID----------------------------", pid);
		window.scrollTo(0,0);
		if (pid !== undefined) {
			builduserInfo().then((ci) => {
				if (ci) {
					ci.touchTownUpdatedBy = "ServicePortal";
					const employeeName = localStorage
						.getItem("fullName")
						?.replace(".", " ");
					let eName = employeeName?.split(" ");
					if (eName) {
						for (let i = 0; i < eName.length; i++) {
							eName[i] = eName[i].charAt(0).toUpperCase() + eName[i].slice(1);
						}
					}
					ci.updatedBy = eName?.join(" ");
					setInitialUserInfo(ci);
					setUserInfo(ci);
				} else {
					setError("Error building user info");
				}
			});
			return;
		}
		setInitialUserInfo(userInfo);
		setUserInfo(userInfo);
	}, [pid]);

	useEffect(() => {
		async function getGroupDetails() {
			const username = localStorage.getItem("userName");
			if (username) {
				const g = await AdminService.getGroupsForUser(username);
				const groupArr = g.map((gx) => gx.GroupName);
				setAccess(intersection(["Admin"], groupArr).length > 0);
			}
		}
		getGroupDetails();
	}, []);

	const builduserInfo = async () => {
		const userQuery = await IntakeService.getResident(pid);
		if (userQuery.data?.getResident) {
			return userQuery.data?.getResident;
		}
		return;
	};

	const formatDate = (date?: string) => {
		return date ? moment(date.replace(/T.*/, "")).format("MM/DD/YYYY") : "";
	};


	const handleSave = async () => {
		try {
			if (pid) {
				console.log(userInfo);
				await IntakeService.updateResident(userInfo as UpdateResidentInput);
				await EventService.auditLog("update", pid, initialUserInfo, userInfo);
			} else {
				console.log("No change");
			}
			handleUpdate();
		} catch (err) {
			console.log("Error Updating the User", err);
		}
	};

	const handleUpdate = () => {
		props.history.push(`/`);
	};

	const handleNav = () => {
		props.history.push(`/`);
	};
	const [emailError, setEmailError] = useState("");

	const validateEmail = (field: string, value: string | null) => {
		let obj: any = {};
		obj[field] = value;

		if (validator.isEmail(value)) {
			setEmailError("");
		} else {
			setEmailError("Please enter valid email address!");
		}

		setUserInfo({
			...userInfo,
			...obj,
		});
	};

	// const handleInputChange = (field: string, value: string | null | boolean) => {
	// 	let obj: any = {};
	// 	obj[field] = value;
	// 	setUserInfo({
	// 		...userInfo,
	// 		...obj,
	// 	});
	// };

	const handleInputChange = (field: string, value: string | null | boolean) => {

		if (field === 'activeAdmission' || field === 'firstAdmission') {
			return;  // Exit the function if the field is one of the excluded ones
		}
		let obj: any = { ...userInfo };

		const keys = field.split('.');

		if (keys.length > 1) {
			// Handle nested properties like 'profile.includeInDirectory'
			let nestedObj = obj;
			for (let i = 0; i < keys.length - 1; i++) {
				if (!nestedObj[keys[i]]) {
					// Create the nested object path if it doesn't exist
					nestedObj[keys[i]] = {};
				}
				nestedObj = nestedObj[keys[i]];
			}
			nestedObj[keys[keys.length - 1]] = value;
		} else {
			obj[field] = value;
		}

		setUserInfo(obj);
	};

	const phoneInfoChange = (
		field: string,
		value: string | boolean | null,
		position: number
	) => {
		setUserInfo((prevUserInfo) => {
			if (!prevUserInfo) return prevUserInfo;

			const phones = [...(prevUserInfo.contactInfo?.phones || [])];

			if (position < phones.length) {
				phones[position] = {
					...phones[position],
					[field]: value,
				};
			}

			return {
				...prevUserInfo,
				contactInfo: {
					...prevUserInfo.contactInfo,
					phones,
				},
			};
		});
	};

	return (
		<React.Fragment>

			<Grid container spacing={3} style={{ marginBottom: "16px" }}>
				{[
					{ label: "Active", field: "active", value: userInfo?.active },
					{
						label: "Activation Status",
						field: "activationStatus",
						value: userInfo?.activationStatus,
					},
					{ label: "Locked", field: "locked", value: userInfo?.locked },
					{
						label: "First Admission",
						field: "firstAdmission",
						value: userInfo?.firstAdmission,
					},
					{
						label: "Active Admission",
						field: "activeAdmission",
						value: userInfo?.activeAdmission,
						editable: false,
					},
					{
						label: "Include In Directory",
						field: "profile.includeInDirectory",
						value: userInfo?.profile?.includeInDirectory,
					},
					{
						label: "Calendar Enabled",
						field: "profile.externalCalendarEnabled",
						value: userInfo?.profile?.externalCalendarEnabled,
						editable: false,
					},
				].map((item, index) => (
					<Grid item xs={12} sm={6} md={4} key={index}>
						<FormControlLabel
							control={
								<Checkbox
									checked={Boolean(item.value)}
									onChange={(event) => handleInputChange(item.field, event.target.checked)}
									disabled={item.editable === false}
								/>
							}
							label={item.label}
							classes={{ root: classes.label }}
						/>
					</Grid>
				))}
			</Grid>

			<Grid container spacing={3}>
				{[
					{ label: "Person Type", value: userInfo?.personType, editable: false, },
					{ label: "ID", value: userInfo?.id, editable: false, },
					{ label: "Sales Force ID", value: userInfo?.salesforceID, editable: false, },
					{ label: "First Name", value: userInfo?.firstName, editable: false, },
					{ label: "Middle Name", value: userInfo?.middleName, editable: false, },
					{ label: "Last Name", value: userInfo?.lastName, editable: false, },
					{ label: "Community", value: userInfo?.community, editable: false, },
					{
						label: "Active Community",
						value: userInfo?.activeCommunity,
						editable: false,
					},
					{
						label: "Active Admission ID",
						value: userInfo?.activeAdmissionId,
						editable: false,
					},
					{
						label: "MRN",
						value: userInfo?.mrn,
						editable: false,
					},

					{
						label: "Date of Activation",
						value: formatDate(userInfo?.activationStartDate ? userInfo.activationStartDate : ""),
						editable: false,
					},
					{
						label: "Activation End Date",
						value: formatDate(userInfo?.activationEndDate ? userInfo.activationEndDate : ""),
						editable: false,
					},
					{
						label: "Ping Access Date",
						value: formatDate(userInfo?.pingAccessStartDate ? userInfo.pingAccessStartDate : ""),
						editable: false,
					},
					{
						label: "Leave Start Date",
						value: formatDate(userInfo?.leaveStartDate ? userInfo.leaveStartDate : ""),
						editable: false,
					},
					{
						label: "Last Login Date",
						value: formatDate(userInfo?.lastLoginDateTime ? userInfo.lastLoginDateTime : ""),
						editable: false,
					},
					{ label: "Gender", value: userInfo?.gender, editable: false, },
					{ label: "Preferred Name", value: userInfo?.preferredName, editable: false, },

					{
						label: "Preferred First Name",
						value: userInfo?.preferredFirstName,
						editable: true,
					},
					{
						label: "Date of Birth",
						value: formatDate(userInfo?.birthDate ? userInfo.birthDate : ""),
						editable: false,
					},
					{
						label: "Death Date",
						value: formatDate(userInfo?.deathDate ? userInfo.deathDate : ""),
						editable: false,
					},
					{
						label: "Active Level of Care",
						value: userInfo?.activeLevelOfCare,
						editable: false,
					},
					{
						label: "Location ID",
						value: userInfo?.locationID, editable: false,
					},
					{
						label: "Status",
						value: userInfo?.status,
						editable: false,
					},
					{
						label: "Birth Place",
						value: userInfo?.profile?.birthPlace,
						editable: false,
					},
				].map((item, index) => (
					<Grid item xs={12} sm={6} md={4} key={index}>
						<FormControl className={classes.formControl} variant="outlined">
							<InputLabel
								htmlFor={`field-${index}`}
								className={classes.labelText}
								shrink={true}
							>
								{item.label}
							</InputLabel>
							<OutlinedInput
								id={`field-${index}`}
								value={item.value || ""}
								label={item.label}
								className={classes.input}
								notched={true}
								disabled={item.editable === false}
								onChange={item.label === "Preferred First Name" ? (e) => handleInputChange("preferredFirstName", e.target.value) : undefined}
							/>
						</FormControl>
					</Grid>
				))}
			</Grid>

			<Grid container spacing={3} style={{ marginBottom: "16px" }}>
				{/* Outer container for consistent spacing */}
				<Grid item xs={12}>
					{/* Title of the box, styled separately */}
					<Typography variant="h6" className={classes.title}>
						Meal Information
					</Typography>

					{/* Create a box using Paper for consistent style */}
					<Paper className={classes.paper}>
						{/* Container for fields inside the Meal Information box */}
						<Grid container spacing={3}>
							{[
								{ label: "Meal Type", value: userInfo?.customData?.mealPlan?.type },
								{ label: "Meal Title", value: userInfo?.customData?.mealPlan?.title },
								{ label: "Description", value: userInfo?.customData?.mealPlan?.description },
								{ label: "Balance", value: String(userInfo?.customData?.mealPlan?.balance) },
								{ label: "Total", value: String(userInfo?.customData?.mealPlan?.total) },
								{ label: "Period", value: userInfo?.customData?.mealPlan?.period },
							].map((item, index) => (
								<Grid item xs={12} sm={6} md={4} key={index}>
									<FormControl
										className={classes.formControl}
										variant="outlined"
										fullWidth
									>
										<InputLabel
											htmlFor={`meal-field-${index}`}
											className={classes.labelText}
											shrink={true}
										>
											{item.label}
										</InputLabel>
										<OutlinedInput
											id={`meal-field-${index}`}
											value={item.value || ""}
											label={item.label}
											readOnly
											disabled
											className={classes.input}
											notched={true}
										/>
									</FormControl>
								</Grid>
							))}
						</Grid>
					</Paper>
				</Grid>
			</Grid>

			<Typography variant="h6" className={classes.title}>
				Address Information
			</Typography>
			<Paper className={classes.paper} style={{ marginBottom: "16px" }}>
				<Grid container spacing={3}>
					{/* First row for Address and Address Line 2 */}
					<Grid container item xs={12} spacing={3}>
						<Grid item xs={12} sm={6}>
							<FormControl
								className={classes.formControl}
								variant="outlined"
							>
								<InputLabel
									htmlFor="address"
									className={classes.labelText}
									shrink={true}
								>
									Address
								</InputLabel>
								<OutlinedInput
									id="address"
									value={userInfo?.address?.addressLine1 || ""}
									label="Address"
									readOnly
									disabled
									className={classes.input}
									notched={true}
								/>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={6}>
							<FormControl
								className={classes.formControl}
								variant="outlined"
							>
								<InputLabel
									htmlFor="address-line-2"
									className={classes.labelText}
									shrink={true}
								>
									Address Line 2
								</InputLabel>
								<OutlinedInput
									id="address-line-2"
									value={userInfo?.address?.addressLine2 || ""}
									label="Address Line 2"
									readOnly
									disabled
									className={classes.input}
									notched={true}
								/>
							</FormControl>
						</Grid>
					</Grid>

					{/* Second row for City, State, and Zip Code */}
					<Grid container item xs={12} spacing={3}>
						<Grid item xs={12} sm={4}>
							<FormControl
								className={classes.formControl}
								variant="outlined"
							>
								<InputLabel
									htmlFor="city"
									className={classes.labelText}
									shrink={true}
								>
									City
								</InputLabel>
								<OutlinedInput
									id="city"
									value={userInfo?.address?.city || ""}
									label="City"
									readOnly
									disabled
									className={classes.input}
									notched={true}
								/>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={4}>
							<FormControl
								className={classes.formControl}
								variant="outlined"
							>
								<InputLabel
									htmlFor="state"
									className={classes.labelText}
									shrink={true}
								>
									State
								</InputLabel>
								<OutlinedInput
									id="state"
									value={userInfo?.address?.state || ""}
									label="State"
									readOnly
									disabled
									className={classes.input}
									notched={true}
								/>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={4}>
							<FormControl
								className={classes.formControl}
								variant="outlined"
							>
								<InputLabel
									htmlFor="zipcode"
									className={classes.labelText}
									shrink={true}
								>
									Zip Code
								</InputLabel>
								<OutlinedInput
									id="zipcode"
									value={userInfo?.address?.zipcode || ""}
									label="Zip Code"
									readOnly
									disabled
									className={classes.input}
									notched={true}
								/>
							</FormControl>
						</Grid>
					</Grid>
				</Grid>
			</Paper>

			<Typography variant="h5" className={classes.sectionTitle}>
				Contact Information
			</Typography>
			<Paper className={classes.paper} style={{ marginBottom: "20px" }}>
				<Grid container spacing={3}>
					{/* Row for Type 1, Phone 1, Preferred 1, and Hidden 1 */}
					<Grid container item xs={12} spacing={2}>
						<Grid item xs={3}>
							<FormControl
								className={classes.formControl}
								variant="outlined"

							>
								<InputLabel
									htmlFor="type1"
									className={classes.labelText}
									shrink={true}
								>
									Type
								</InputLabel>
								<OutlinedInput
									id="type1"
									value={userInfo?.contactInfo?.phones![0]?.type || ""}
									label="Type 1"
									readOnly
									disabled
									className={classes.input}
									notched={true}
								/>
							</FormControl>
						</Grid>
						<Grid item xs={3}>
							<FormControl
								className={classes.formControl}
								variant="outlined"
								fullWidth
							>
								<InputLabel
									htmlFor="phone1"
									className={classes.labelText}
									shrink={true}
								>
									Phone
								</InputLabel>
								<OutlinedInput
									id="phone1"
									value={userInfo?.contactInfo?.phones![0]?.value || ""}
									onChange={(e) => phoneInfoChange("value", e.target.value, 0)}
									label="Phone 1"
									className={classes.input}
									notched={true}
								/>
							</FormControl>
						</Grid>
						<Grid item xs={3}>
							<FormControlLabel
								control={
									<Checkbox
										checked={Boolean(userInfo?.contactInfo?.phones![0]?.preferred)}
										onChange={(e) => phoneInfoChange("preferred", e.target.checked, 0)}
									/>
								}
								label="Preferred"
							/>
						</Grid>
						<Grid item xs={3}>
							<FormControlLabel
								control={
									<Checkbox
										checked={Boolean(userInfo?.contactInfo?.phones![0]?.hidden)}
										onChange={(e) => phoneInfoChange("hidden", e.target.checked, 0)}
									/>
								}
								label="Hidden"
							/>
						</Grid>
					</Grid>

					{/* Row for Type 2, Phone 2, Preferred 2, and Hidden 2 */}
					<Grid container item xs={12} spacing={2}>
						<Grid item xs={3}>
							<FormControl
								className={classes.formControl}
								variant="outlined"
								fullWidth
							>
								<InputLabel
									htmlFor="type2"
									className={classes.labelText}
									shrink={true}
								>
									Type
								</InputLabel>
								<OutlinedInput
									id="type2"
									value={userInfo?.contactInfo?.phones![1]?.type || ""}
									label="Type 2"
									readOnly
									disabled
									className={classes.input}
									notched={true}
								/>
							</FormControl>
						</Grid>
						<Grid item xs={3}>
							<FormControl
								className={classes.formControl}
								variant="outlined"
								fullWidth
							>
								<InputLabel
									htmlFor="phone2"
									className={classes.labelText}
									shrink={true}
								>
									Phone
								</InputLabel>
								<OutlinedInput
									id="phone2"
									value={userInfo?.contactInfo?.phones![1]?.value || ""}
									onChange={(e) => phoneInfoChange("value", e.target.value, 1)}
									label="Phone 2"
									className={classes.input}
									notched={true}
								/>
							</FormControl>
						</Grid>
						<Grid item xs={3}>
							<FormControlLabel
								control={
									<Checkbox
										checked={Boolean(userInfo?.contactInfo?.phones![1]?.preferred)}
										onChange={(e) => phoneInfoChange("preferred", e.target.checked, 1)}
									/>
								}
								label="Preferred"
							/>
						</Grid>
						<Grid item xs={3}>
							<FormControlLabel
								control={
									<Checkbox
										checked={Boolean(userInfo?.contactInfo?.phones![1]?.hidden)}
										onChange={(e) => phoneInfoChange("hidden", e.target.checked, 1)}
									/>
								}
								label="Hidden"
							/>
						</Grid>
					</Grid>

					{/* Row for Type 3, Phone 3, Preferred 3, and Hidden 3 */}
					<Grid container item xs={12} spacing={2}>
						<Grid item xs={3}>
							<FormControl
								className={classes.formControl}
								variant="outlined"
								fullWidth
							>
								<InputLabel
									htmlFor="type3"
									className={classes.labelText}
									shrink={true}
								>
									Type
								</InputLabel>
								<OutlinedInput
									id="type3"
									value={userInfo?.contactInfo?.phones![2]?.type || ""}
									label="Type 3"
									readOnly
									disabled
									className={classes.input}
									notched={true}
								/>
							</FormControl>
						</Grid>
						<Grid item xs={3}>
							<FormControl
								className={classes.formControl}
								variant="outlined"
								fullWidth
							>
								<InputLabel
									htmlFor="phone3"
									className={classes.labelText}
									shrink={true}
								>
									Phone
								</InputLabel>
								<OutlinedInput
									id="phone3"
									value={userInfo?.contactInfo?.phones![2]?.value || ""}
									onChange={(e) => phoneInfoChange("value", e.target.value, 2)}
									label="Phone 3"
									className={classes.input}
									notched={true}
								/>
							</FormControl>
						</Grid>
						<Grid item xs={3}>
							<FormControlLabel
								control={
									<Checkbox
										checked={Boolean(userInfo?.contactInfo?.phones![2]?.preferred)}
										onChange={(e) => phoneInfoChange("preferred", e.target.checked, 2)}
									/>
								}
								label="Preferred"
							/>
						</Grid>
						<Grid item xs={3}>
							<FormControlLabel
								control={
									<Checkbox
										checked={Boolean(userInfo?.contactInfo?.phones![2]?.hidden)}
										onChange={(e) => phoneInfoChange("hidden", e.target.checked, 2)}
									/>
								}
								label="Hidden"
							/>
						</Grid>
					</Grid>

					{/* Row for Cell */}
					<Grid container item xs={12} spacing={2}>
						<Grid item xs={3}>
							<FormControl
								className={classes.formControl}
								variant="outlined"
								fullWidth
							>
								<InputLabel
									htmlFor="cell"
									className={classes.labelText}
									shrink={true}
								>
									Cell
								</InputLabel>
								<OutlinedInput
									id="cell"
									value={userInfo?.cell || ""}
									label="Cell"
									readOnly
									disabled
									className={classes.input}
									notched={true}
								/>
							</FormControl>
						</Grid>
					</Grid>

					{/* Row for MyUnity Email and TouchTown Email */}
					<Grid container item xs={12} spacing={2}>
						<Grid item xs={6}>
							<FormControl
								className={classes.formControl}
								variant="outlined"
								fullWidth
							>
								<InputLabel
									htmlFor="personalEmail"
									className={classes.labelText}
									shrink={true}
								>
									MyUnity Email
								</InputLabel>
								<OutlinedInput
									id="personalEmail"
									value={userInfo?.personalEmail || ""}
									onChange={(event) => handleInputChange("personalEmail", event.target.value)}
									label="MyUnity Email"
									className={classes.input}
									notched={true}
								/>
							</FormControl>
						</Grid>
						<Grid item xs={6}>
							<FormControl
								className={classes.formControl}
								variant="outlined"
								fullWidth
							>
								<InputLabel
									htmlFor="email"
									className={classes.labelText}
									shrink={true}
								>
									TouchTown Email
								</InputLabel>
								<OutlinedInput
									id="email"
									value={userInfo?.email || ""}
									onChange={(event) => handleInputChange("email", event.target.value)}
									label="TouchTown Email"
									className={classes.input}
									notched={true}
								/>
							</FormControl>
						</Grid>
					</Grid>
				</Grid>
			</Paper>

      <Grid container spacing={3} style={{ marginBottom: "16px" }}>
				{/* Outer container for consistent spacing */}
				<Grid item xs={12}>
					{/* Title of the box, styled separately */}
					<Typography variant="h6" className={classes.title}>
						Profile Information
					</Typography>

					{/* Create a box using Paper for consistent style */}
					<Paper className={classes.paper}>
						{/* Container for fields inside the Meal Information box */}
						<Grid container spacing={2}>
							{[
								{ label: "About Me", value: userInfo?.profile?.aboutMe },
								{ label: "Favorite Things", value: userInfo?.profile?.favoriteThings },
								{ label: "Interests", value: userInfo?.profile?.interests },
								{ label: "Profession", value: String(userInfo?.profile?.profession) },
							].map((item, index) => (
								<Grid item xs={12} key={index}>
									<FormControl
										className={classes.formControl}
										variant="outlined"
										fullWidth
									>
										<InputLabel
											htmlFor={`profile-field-${index}`}
											className={classes.labelText}
											shrink={true}
										>
											{item.label}
										</InputLabel>
										<OutlinedInput
											id={`profile-field-${index}`}
											value={item.value || ""}
											label={item.label}
											readOnly
											disabled
                      multiline
                      minRows={1}
                      maxRows={4}
											className={classes.input}
											notched={true}
                      inputProps={{
												style: { overflow: "hidden" }, // Hide scrollbar
											}}
										/>
									</FormControl>
								</Grid>
							))}
						</Grid>
					</Paper>
				</Grid>
			</Grid>

			<Grid>
				<Typography variant="h6">{"Note:"}</Typography>
				<Grid
					item
					xs={12}
					sm={12}
					md={4}
					justifyContent="center"
					className={classes.label}
				>
				</Grid>
				<Grid
					item
					xs={12}
					sm={12}
					md={8 as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12}
				>
					<TextField
						id="outlined-multiline-flexible"
						fullWidth
						multiline
						maxRows={4}
						variant="filled"
						placeholder="Please write a reason for a change or an update"
						value={userInfo?.note || ""}
						// onBlur={event => handleInputBlur('address', event.target.value as string)}
						onChange={(event) => handleInputChange("note", event.target.value)}
					/>
				</Grid>
			</Grid>

			<div style={{ float: "right", paddingTop: "12px" }}>
				<Button onClick={handleNav} color="primary">
					Cancel
				</Button>
				<Button onClick={handleSave} color="success" variant="contained">
					Save
				</Button>
			</div>
		</React.Fragment>
	);
}
